'use strict';

var styled = require('styled-components');
var cell = require('./cell.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const CellSubTextStyled = styled__default.default(cell.Cell) `
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
`;
const SubTextContainer = styled__default.default.div `
  font-size: ${({ theme }) => theme.typography.fontSize.xs};
  color: ${({ theme }) => theme.colors.body.textDark};
`;

exports.CellSubTextStyled = CellSubTextStyled;
exports.SubTextContainer = SubTextContainer;
//# sourceMappingURL=cellSubText.styles.js.map
